import React, { useEffect } from 'react';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import '../Timesheets/SideDrawer/SideDrawer.css';
import { useState } from 'react';
import { addLogTime } from '../../services/TimingService';
import {
  Box,
  Select,
  InputLabel,
  MenuItem,
  Button,
  TextField,
  FormControl,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { ERROR_KEY, SHOW_NOTIFICATION } from '../../constants';
import './NewTimelogAddition.css';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import moment from 'moment';

import {
  getSecondsFromHHMMSS,
  getHHMMSSFromSeconds,
} from '../../utils/TimeConversionFunctions';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';

const NewTimelogAddition = (props) => {
  const { setIsEdit } = props;
  const [deviceName, setDeviceName] = useState('');
  const [direction, setDirection] = useState('');
  const [logTimeValue, setlogTimeValue] = useState(undefined);

  const updateLogtime = () => {
    const convertIntoTimestamp = logTimeValue?.$d.toString().split(' ')[4];

    let newLogTime = {
      deviceName: deviceName,
      direction: direction,
      logTime: convertIntoTimestamp,
      logDateTime: props.selectedDate + 'T' + convertIntoTimestamp,
      logDate: props.selectedDate,
      employeeId: props.employeeId,
    };
    console.log('newLogTime: ', newLogTime);
    return newLogTime;
  };
  const dispatch = useDispatch();
  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const [time, setTime] = React.useState('00:00');
  const [timeErrorMsg, setTimeErrorMsg] = React.useState('');

  const [fieldError, setFieldError] = React.useState({
    project: false,
    taskType: false,
    taskTitle: false,
    timeDuration: false,
  });
  const [errorMsg, setErrorMsg] = React.useState({
    project: '',
    taskType: '',
    taskTitle: '',
    timeDuration: '',
  });
  const TaskFieldError = {
    INVALID_DURATION: '*Please enter a valid time duration',
    NUMBER_GREATER_THAN: 'Number of hours can not be greater than ',
    NUMBER_IS_ZERO: 'Duration must be greater than zero ',
    REQUIRED: '*Required',
  };

  const onBlur = (event) => {
    const value = event.target.value;
    const validatedTime = hourValidation(value);
    setTime(getHHMMSSFromSeconds(validatedTime));
  };

  const hourValidation = (value, index, timingsIndex) => {
    let sec = 0;
    if (value === null) {
      sec = 0;
    } else {
      sec = Math.max(0, getSecondsFromHHMMSS(value));
    }
    const secInADay = 23 * 60 * 60 + 59 * 60;
    setFieldError((prev) => {
      return { ...prev, timeDuration: false };
    });
    setErrorMsg((prev) => {
      return {
        ...prev,
        timeDuration: '',
      };
    });
    let hours = 0;
    let minutes = 0;
    if (value === null) {
      hours = 0;
      minutes = 0;
    } else {
      const [inputHours, inputMinutes] = value.split(':');
      hours = parseInt(inputHours, 10);
      minutes = parseInt(inputMinutes, 10);
    }
    // Convert the hours and minutes to numbers

    if (
      logTimeValue == undefined ||
      sec > secInADay ||
      sec <= 0 ||
      minutes > 59
    ) {
      const newErrorMessage = TaskFieldError.INVALID_DURATION;
      setTimeErrorMsg(newErrorMessage);

      if (
        logTimeValue == undefined ||
        index == undefined ||
        index == null ||
        timingsIndex == null ||
        timingsIndex == undefined
      ) {
        setFieldError((prev) => {
          return { ...prev, timeDuration: true };
        });
        setErrorMsg((prev) => {
          return {
            ...prev,
            timeDuration: `${TaskFieldError.INVALID_DURATION}`,
          };
        });
      }
      return 0;
    } else {
      if (index == undefined || index == null) {
        setFieldError((prev) => {
          return { ...prev, timeDuration: false };
        });
        setErrorMsg((prev) => {
          return {
            ...prev,
            timeDuration: '',
          };
        });
      }
      return sec;
    }
  };

  const addLogTiming = async () => {
    props.setShowModal(false);
    const addLogTimeResponse = await addLogTime(updateLogtime());
    console.log(addLogTimeResponse.status);
    dipatchNotification(addLogTimeResponse.type, addLogTimeResponse.message);

    if (addLogTimeResponse.status == 200) {
      props.rawTimings();
    }
    setIsEdit(true);
  };

  const handleDeviceNameChange = (event) => {
    setDeviceName(event.target.value);
  };
  const handleDirectionChange = (event) => {
    setDirection(event.target.value);
  };
  const OnCancel = () => {
    props.setShowModal(false);
  };
  return (
    <FormControl className="NormalizationAddFormControl">
      <form className="NewTimeLogForm" onSubmit={addLogTiming}>
        <Box
          sx={{
            width: '100%',
            height: '90%',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <FormControl sx={{ width: '100%' }}>
            <InputLabel id="device-dropdown-label">Device Name*</InputLabel>
            <Select
              name="Device Name*"
              labelId="device-dropdown-label"
              label="Device Name*"
              value={deviceName}
              onChange={handleDeviceNameChange}
              sx={{
                color: 'black',
                width: '100%',
                margin: 'auto',
                '&:focus': {
                  boxShadow: 'none',
                  borderBottomLeftRadius: 0,
                  borderBottomRightRadius: 0,
                },
              }}
              required
            >
              <MenuItem value={'ground Floor'}>Ground Floor</MenuItem>
              <MenuItem value={'Third Floor-2'}>Third Floor-2</MenuItem>
              <MenuItem value={'gurgon'}>Gurgaon</MenuItem>
              <MenuItem value={'Second Floor'}>Second Floor</MenuItem>
            </Select>
          </FormControl>

          <FormControl sx={{ width: '100%', marginTop: '1.5rem' }}>
            <InputLabel id="direction-select-label">Direction*</InputLabel>
            <Select
              name="Direction*"
              labelId="direction-select-label"
              label="Direction*"
              value={direction}
              onChange={handleDirectionChange}
              sx={{
                color: 'black',
                width: '100%',
                margin: 'auto',
                '&:focus': {
                  boxShadow: 'none',
                  borderBottomLeftRadius: 0,
                  borderBottomRightRadius: 0,
                },
              }}
              required
            >
              <MenuItem value={'in'}>in</MenuItem>
              <MenuItem value={'out'}>out</MenuItem>
            </Select>
          </FormControl>

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <TimePicker
              onViewChange={() => {
                setFieldError((prev) => {
                  return { ...prev, timeDuration: false };
                });
                setErrorMsg((prev) => {
                  return {
                    ...prev,
                    timeDuration: '',
                  };
                });
              }}
              ampm={false}
              label="Time"
              value={logTimeValue ? logTimeValue : {}}
              onChange={(time) => {
                if (time?.$d.toString() == 'Invalid Date') {
                  setFieldError((prev) => {
                    return { ...prev, timeDuration: true };
                  });
                  setErrorMsg((prev) => {
                    return {
                      ...prev,
                      timeDuration: `${TaskFieldError.INVALID_DURATION}`,
                    };
                  });
                } else {
                  setFieldError((prev) => {
                    return { ...prev, timeDuration: false };
                  });
                  setErrorMsg((prev) => {
                    return {
                      ...prev,
                      timeDuration: '',
                    };
                  });
                  setlogTimeValue(time);
                  setTime(moment(new Date(time)).format('HH:mm'));
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  onBlur={onBlur}
                  error={fieldError.timeDuration}
                  helperText={errorMsg.timeDuration}
                  required
                  style={{ marginTop: '1.5rem' }}
                />
              )}
            />
          </LocalizationProvider>
          <Box className="ButtonContainer">
            <Button
              className="NormalizationCancelButton"
              variant="outlined"
              color={ERROR_KEY}
              onClick={OnCancel}
            >
              Cancel
            </Button>
            <Button
              className="NormalizationSubmitButton"
              type="submit"
              disabled={errorMsg.timeDuration !== ''}
            >
              Submit
            </Button>
          </Box>
        </Box>
      </form>
    </FormControl>
  );
};
export default NewTimelogAddition;
